module.exports = __webpack_public_path__ + "static/media/img1.fab6ed42.jpg";